

























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import StepMixin from '@mixin/step';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            next: false,
        };
    },

    mixins: [
        StepMixin,
    ],

    computed: {
        ...mapGetters({
            currentProject: 'project/current'
        }),

        yesButton() {
            return `/apply/${ this.projectId }/applicant/add-contact`;
        },

        noButton() {
            return `/apply/${ this.projectId }/applicant/statuten-vereist`;
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class AddContactQuestion extends Vue {}

